import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";
import { toast } from 'react-toastify';

export const TotalSalesSlice = createAsyncThunk("admin/admin-sales",async (_, { rejectWithValue }) => {
    try {
      const response = await api.TotalSalesSlicesApi();
      console.log("response:",response);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const LeastsellingproductSlices = createAsyncThunk("admin/admin-ListNotificationSlicesApi",async (_, { rejectWithValue }) => {
    try {
      const response = await api.LeastsellingproductApi();
      console.log("response:",response);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const TopsellingproductSlices = createAsyncThunk("admin/admin-TopsellingproductSlicesApi",async (_, { rejectWithValue }) => {
    try {
      const response = await api.TopsellingproductSlicesApi();
      console.log("response:",response);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const TotalusersSlices = createAsyncThunk("admin/admin-TotalusersSlicesApi",async (_, { rejectWithValue }) => {
    try {
      const response = await api.TotalusersSlicesApi();
      console.log("response:",response);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const TotalrevenueSlices = createAsyncThunk("admin/admin-TotalrevenueSlicesApi",async (_, { rejectWithValue }) => {
    try {
      const response = await api.TotalrevenueSlicesApi();
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const SaleAnalyticsSlice = createSlice({
  name: 'Sale analytics',
  initialState: {
    data: [],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      toast.error(state.error);
    }

    builder
      .addCase(TotalSalesSlice.pending,handlePendingState)
      .addCase(TotalSalesSlice.fulfilled, (state, action) => {
        state.data = action.payload.data; 
        state.loading = false;
        // toast.success("Login Successfuly!"); 
      })
      .addCase(TotalSalesSlice.rejected,handleRejectState);
  },
});


export default SaleAnalyticsSlice.reducer;
